<template>

    <!-- <el-button size="small" type="success" plain="" @click="dialogVisible = true">Importar productos</el-button> -->

    <el-dialog
        title="Importar productos"
        width="30%"
        :visible="showDialog"
        @close="closeModal"
        @open="initForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body>
        
        <div class="row">
            <div class="col-12 text-center">
                <el-checkbox label="Ajuste stock y peso"
                    v-model="data.adjust_stock_and_weight"
                ></el-checkbox>
            </div>
            <div class="col-12 text-center mt-3">
                <el-upload
                    ref="upload"
                    accept=".xlsx, .xls"
                    :data="data"
                    class="upload-demo"
                    action="/dispatches/extract_products"
                    :show-file-list="false"
                    :headers="uploadHeaders"
                    :on-progress="handleProgress"
                    :on-success="handleSuccess"
                >
                    <el-button size="small" type="success" plain>Añadir archivo</el-button>
                </el-upload>
                <br>
                <small>
                    <a class="text-dark mr-auto" href="/formats/add_products_dispatches.xlsx" target="_new">
                        <span class="mr-2">Descargar formato de ejemplo</span>
                        <i class="fa fa-download"></i>
                    </a>
                </small>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showDialog = false">Cancelar</el-button>
        </span>
        
    </el-dialog>
</template>

<script>
    export default {
        name: "AddProductsExcel",
        props: ['showDialog'],

        data() {
            return {
                loading: null,
                uploadHeaders: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                dialogVisible: false,
                data: {
                    adjust_stock_and_weight: false
                }
            }
        },

        methods: {
            handleProgress(event, file , fileList) {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Se está procesando la información, por favor espere.',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },

            handleSuccess(response, files, fileList) {
                let message = ''
                if (response.data) {
                    message = `<strong>Productos en excel: ${response.data.total_rows}</strong><br>
                        <strong>✅ Cargados correctamente: ${response.data.total_success}</strong><br>
                        <strong>❌ No cargados: ${response.data.total_fail}</strong><br>`
                    if (response.data.total_fail > 0) {
                        message += `<small class="text-danger" style="font-style: italic">${response.data.total_fail} producto(s) no encontrado(s) de acuerdo al codigo interno proporcionado</small>`
                    }

                    if (response.data.list_products.length > 0) {
                        this.$emit('addItems', response.data.list_products, this.data.adjust_stock_and_weight)
                        this.$emit('update:showDialog', false)
                    }
                }

                this.loading.close()

                this.$notify({
                    title: response.message,
                    dangerouslyUseHTMLString: true,
                    message: message,
                    position: 'bottom-right',
                    duration: 10000
                })

                this.$refs.upload.clearFiles()
            },

            initForm() {
                this.data = {
                    adjust_stock_and_weight: false
                }
            },

            closeModal() {
                this.$emit('update:showDialog', false)
                this.initForm()
                this.$refs.upload.clearFiles()
            },

            handleClose(done) {
                this.initForm()
                this.$refs.upload.clearFiles()
                done()
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/dispatches/partials/AddProductsExcel.vue